import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#map_print_dialog', () => {
  void import('./internal/map_print_dialog').then(({ default: Component }) => Component());
});
